export enum ProposalStatus {
  AwaitingSubmission = "AwaitingSubmission",
  AwaitingApprovalByClient = "AwaitingApprovalByClient",
  AwaitingApprovalByTeamLeader = "AwaitingApprovalByTeamLeader",
  AwaitingApprovalByVendors = "AwaitingApprovalByVendors",
  AwaitingApprovalByTeam = "AwaitingApprovalByTeam",
  AwaitingHire = "AwaitingHire",
  RevisionRequested = "RevisionRequested",
  Archived = "Archived"
}

export enum HumanReadableProposalStatus {
  AwaitingSubmission = 'Awaiting Submission',
  AwaitingApprovalByClient = 'Awaiting Client Approval',
  AwaitingApprovalByTeamLeader = 'Awaiting Team Leader Approval ',
  AwaitingApprovalByVendors = 'Awaiting Vendor Approval ',
  AwaitingApprovalByTeam = 'Awaiting Team Approval',
  AwaitingHire = 'Awaiting Hire',
  AwaitingFurtherRevision = 'Awaiting Further Revision',
  RevisionRequested = 'Revision Requested',
  Canceled = 'Canceled',
  Archived = 'Archived',
  Unknown = 'Unknown'
}

export const proposalActor = {
  Client: 0,
  Vendor: 1,
  TeamLeader: 2,
  TeamMember: 3,
  Unknown: 4
};

export enum ProposalAction {
  Submit = "Submit",
  Approve = "Approve",
  Reject = "Reject",
  Revise = "Revise",
  Hire = "Hire",
  Delete = "Delete",
  Cancel = "Cancel",
  Edit = "Edit",
  Review = "Review"
}

export enum ProposalEvent {
  Drafted = "Drafted",
  SubmittedByCreator = "SubmittedByCreator",
  SubmittedByClientTeamLeader = "SubmittedByClientTeamLeader",
  SubmittedByVendorTeamLeader = "SubmittedByVendorTeamLeader",
  SubmittedByAdditionalVendor = "SubmittedByAdditionalVendor",
  SubmittedByVendorTeamMember = "SubmittedByVendorTeamMember",
  ApprovedByVendorTeamLeader = "ApprovedByVendorTeamLeader",
  ApprovedByAdditionalVendor = "ApprovedByAdditionalVendor",
  ApprovedByVendors = "ApprovedByVendors",
  ApprovedByVendorTeamMember = "ApprovedByVendorTeamMember",
  ApprovedByVendorTeam = "ApprovedByVendorTeam",
  ApprovedByClientTeamLeader = "ApprovedByClientTeamLeader",
  Hired = "Hired",
  SubmittedAsRevision = "SubmittedAsRevision",
  RevisionRequested = "RevisionRequested",
  RevisionRejected = "RevisionRejected",
  Revised = "Revised",
  RejectedByClientTeamLeader = "RejectedByClientTeamLeader",
  RejectedByAdditionalVendor = "RejectedByAdditionalVendor",
  RejectedByVendorTeamLeader = "RejectedByVendorTeamLeader",
  RejectedByVendorTeamMember = "RejectedByVendorTeamMember",
  Canceled = "Canceled",
  Finished = "Finished",
  Deleted = "Deleted",
}

export enum ProposalBoxType {
  Draft = "Draft",
  DraftReview = "DraftReview",
  Inbox = "Inbox",
  Outbox = "Outbox",
  ActiveReview = "ActiveReview",
  AllActive = "AllActive",
  Archive = "Archive",
}

export enum ProposalContext {
  Client = "Client",
  Vendor = "Vendor",
  None = "None",
}

export enum ProposalOrderField {
  Created = "Created",
  Name = "Name",
  Start = "Start",
  End = "End",
  ResponseDueBy = "ResponseDueBy",
  Discount = "Discount",
  Updated = "Updated",
  Deleted = "Deleted",
}
